import { useCallback } from 'react';

import { useRouteActions } from '@confluence/route-manager/entry-points/RouteState.ts';
import { createEditDraftPageUrl } from '@confluence/content-utils/entry-points/newContentUrl.ts';

import type { ResponseContentMetadata } from '../services/DocImportService.ts';

export const useGoToDraftPage = (): ((pageData: ResponseContentMetadata | null) => void) => {
	const { push } = useRouteActions();
	return useCallback(
		(pageData: ResponseContentMetadata | null) => {
			if (!pageData) {
				return;
			}
			const importedPageUrl = createEditDraftPageUrl(pageData);
			push(`${importedPageUrl}${importedPageUrl.includes('?') ? '&' : '?'}importSurvey=true`);
		},
		[push],
	);
};
